var core = require("./core").dom.level3.core,
    html = require("../level2/html").dom.level2.html

exports.dom = {
  level3 : {
    html : html,
    core : core
  }
};
